import assistantReducer from "../features/assistant/assistantSlice";
import flowReducer from "../features/flow/flowSlice";
import settingReducer from "../features/settings/settingsSlice";
import userReducer from "../features/user/userSlice";
import platformsReducer from "../features/platforms/platformsSlice";
import knowledgeBaseReducer from "../features/knowledge-base/knowledge-baseSlice";
import configurationReducer from "../features/configuration/configurationSlice";
import twilioReducer from "../features/twilio/twilioSlice";
import transactionReducer from "../features/transaction/transactionSlice";
import organizationReducer from "../features/organization/organizationSlice";
import toolsReducer from "../features/tools/toolsSlice";
import meetingsReducer from "../features/meetings/meetingsSlice";
import tasksReducer from "../features/tasks/taskSlice";
import uploadReducer from "../features/uploads/uploadSlice";
import resourceReducer from "../features/resource/resourceSlice";
import cookie from "react-cookies";
import { decodeToken } from "../utils/authHeader";
import agentReducer from "../features/agent/agentSlice";
import participantReducer from "../features/participant/participantSlice";
import integrationRequestReducer from "../features/integration-request/integrationRequestSlice";
import meetingIntegrationsReducer from "../features/meeting-integration/meetingIntegrationSlice";
import integrationSettingReducer from "../features/integration-setting/integrationSettingSlice";
import adminReducer from "../features/admin/adminSlice";

const reducers = {
  assistant: assistantReducer,
  flow: flowReducer,
  setting: settingReducer,
  user: userReducer,
  platforms: platformsReducer,
  knowledgeBase: knowledgeBaseReducer,
  configuration: configurationReducer,
  twilio: twilioReducer,
  transactions: transactionReducer,
  organization: organizationReducer,
  tools: toolsReducer,
  agent: agentReducer,
  meetings: meetingsReducer,
  task: tasksReducer,
  upload: uploadReducer,
  resource: resourceReducer,
  participants: participantReducer,
  integrationRequest: integrationRequestReducer,
  meetingIntegrations: meetingIntegrationsReducer,
  integrationSetting: integrationSettingReducer,  
  admin: adminReducer,
};

export const rootReducer = (state, action) => {
  if (action.type === "RESET") {
    state = undefined;
  }

  if (!state) {
    const token = cookie.load("token");
    if (token) {
      const decoded = decodeToken(token);
      if (decoded?.uuid && decoded?.role) {
        state = {
          user: { user: decoded },
        };
      }
    }
  }

  return Object.keys(reducers).reduce((acc, key) => {
    acc[key] = reducers[key](state?.[key], action);
    return acc;
  }, {});
};
